export enum ElementTypes {
  Button = 'button',
  Card = 'card',
}

export enum ElementActions {
  Click = 'click',
}

export enum ElementNames {
  SmsContact = 'sms_contact',
  WhatsAppContact = 'whatsapp_contact',
  CallContact = 'call_contact',
  EmailContact = 'email_contact',
  DocumentDownload = 'document_download',
  DocumentsActionFab = 'documents_action_fab',
  DocumentsActionFabOption = 'documents_action_fab_option',
  OpenAddressOfContact = 'open_address_contact',
  Shift = 'shift',
  Appointment = 'appointment',
  Task = 'task',
  ResendCode = 'resend_code',
}